import { Box, Text } from '@factorialco/deprecated-design-system'
import { Icon } from '@factorialco/factorial-one-react'

import { icon as cardIcon } from 'modules/banking/lib/cards/icon'
import { last4digits } from 'modules/banking/lib/cards/last4digits'
import { statusColor } from 'modules/banking/lib/cards/statusColor'

import { Card } from './types'

type Props = {
  card: Card
}

export const Last4 = ({ card }: Props) => {
  const last4 = last4digits(card)
  const color = statusColor(card)
  const icon = cardIcon(card.creationSource)

  return (
    <Box flexDirection="row" alignItems="center" gap="s6">
      <Text.Normal color={color}>
        <Icon size="lg" icon={icon} />
      </Text.Normal>
      <Text.Normal size="200">{last4}</Text.Normal>
    </Box>
  )
}
